import { useMemo } from 'react'
import { useBoundStore } from '../../../state/bound.store'
import { selectEditItem } from '../../../state/itineraryState/currentItin.slice'

export const useEditItem = (sectionID: number, _id: string) => {
    const pendingCount = useMemo(() => {
        return selectEditItem(useBoundStore.getState(), sectionID, _id)
    }, [sectionID, _id])

    return pendingCount
}
